import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-exec-compare-details-page',
  templateUrl: './exec-compare-details-page.component.html',
  styleUrls: ['./exec-compare-details-page.component.less']
})
export class ExecCompareDetailsPageComponent implements OnInit {

    @Input() selectedTestData1: any;
    @Input() selectedTestData2: any;
    @Input() differenceData : any;
    @Input() testCaseDetails1 : any;
    @Input() testCaseDetails2 : any;
    activeTabId = 0;
    diffReport: any;

    ngOnInit(): void {
      setTimeout(() => {
        this.compare();
      }, 1000);
    }

    compare() {
      if(document.getElementById('compare') !== null) {
        document.getElementById('compare').click();
      }
    }

    differenceReport(event) {
      this.diffReport = event;
    }

    constructor(private clipboard: Clipboard) { }

    close() {
    }

    changeTab(event: any): void {
      if(event.nextId === 1) {
        setTimeout(() => {
          this.compare();
        }, 500);
      }
    }

    copyText1(item : any){
      const stringValue= JSON.stringify(item.responseBody);

      const pending = this.clipboard.beginCopy(stringValue);
      let remainingAttempts = 3;
      const attempt = () => {
        const result = pending.copy();
        if (!result && --remainingAttempts) {
          setTimeout(attempt);
        } else {
          // Remember to destroy when you're done!
          pending.destroy();
        }
      };
      attempt();
    }

    copyText2(item : any){
      const stringValue= JSON.stringify(item.responseBody);

      const pending = this.clipboard.beginCopy(stringValue);
      let remainingAttempts = 3;
      const attempt = () => {
        const result = pending.copy();
        if (!result && --remainingAttempts) {
          setTimeout(attempt);
        } else {
          // Remember to destroy when you're done!
          pending.destroy();
        }
      };
      attempt();  }

}
